<template>
  <q-expansion-item
    ref="componentRef"
    expand-icon="add"
    expanded-icon="remove"
    v-bind="attrs"
  >
    <template v-for="slot in Object.keys(slots)" #[slot]>
      <slot :name="slot"></slot>
    </template>
  </q-expansion-item>
</template>

<script>
export default { inheritAttrs: false }
</script>

<script setup>
import { useSlots, useAttrs, ref } from 'vue'

const slots = useSlots()
const attrs = useAttrs()

const componentRef = ref(null)

defineExpose({ componentRef })
</script>

<style lang="scss" scoped></style>
